<template>
  <div>
    <a-spin :spinning="loading">
      <div class="neo-tabs">
        <a-tabs :defaultActiveKey="undefined" :tabPosition="this.settings['isMobileView'] ? 'top' : 'left'" @change="handleStudentChange">
          <a-tab-pane
            tab="All students"
            :key="undefined"
          >
            <student-marks-display-all :examData="classExamData" :studentsData="classStudents"/>
          </a-tab-pane>
          <a-tab-pane
            v-for="student in classStudents"
            :tab="`${student.student.first_name} ${student.student.last_name} (${student.roll_no ? student.roll_no : ''})`"
            :key="student.id"
          >
            <student-marks-display-single :studentData="student" :examData="classExamData" :reportsData="reportsData" :remarksData="remarksData" @updateRemarksTable="handleUpdateRemarksTable"/>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>

    <edit-exam-remark
      :enrollmentId="selectedStudentEnrollmentId"
      :classSectionExamId="classSectionExamData ? classSectionExamData.id : ''"
      @edited="handleUpdateRemarksTable"
    />
  </div>
</template>

<script>
import { omit } from 'lodash'
import { mapState } from 'vuex'

import StudentMarksDisplaySingle from '@/components/exam/manage/Report/DisplaySingle/index'
import StudentMarksDisplayAll from '@/components/exam/manage/Report/DisplayAll/index'

import EditExamRemark from '@/components/exam/manage/Report/Remark/Edit/index'

export default {
  name: 'DisplayStudentExamReport',
  props: ['examData'],
  components: {
    StudentMarksDisplaySingle,
    StudentMarksDisplayAll,
    EditExamRemark,
  },
  data: function() {
    return {
      loading: false,
      classSectionExamData: null,
      selectedStudentEnrollmentId: null,
      reportsData: null,
      remarksData: null,
      activeKey: [undefined],
    }
  },
  computed: {
    ...mapState(['settings']),
    classStudents: function() {
      return this.examData.students
    },
    classExamData: function() {
      return omit(this.examData, ['students'])
    },
  },
  methods: {
    handleStudentChange(student) {
      if (student) {
        this.selectedStudentEnrollmentId = student
        this.getStudentExamReport(student)
        this.getStudentRemarks(student)
        // this.$eventBus.$emit('studentChangedExamMarksReport')
      }
    },
    getStudentExamReport(enrollmentId) {
      this.loading = true
      this.$http.get(`/api/reports/student/exam/${this.examData.id}`, {
        params: {
          enrollment_id: enrollmentId,
        },
      }).then(({ data }) => {
        this.loading = false
        this.reportsData = data.data
      })
    },
    getStudentRemarks(enrollmentId) {
      this.loading = true
      this.$http
        .get(`/api/studentexamremarks/${enrollmentId}`, {
          params: {
            class_section_exam_id: this.examData.id,
          },
        })
        .then(({ data }) => {
          this.loading = false
          this.remarksData = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleUpdateRemarksTable() {
      this.getStudentRemarks(this.selectedStudentEnrollmentId)
    },
  },
}
</script>
